<script setup>
import { useAppStore } from '@/store/app'
const app = useAppStore()
</script>

<template>
    <v-snackbar :value="app.messageVisible" @input="app.hideMessage()" vertical>
        {{ app.message }}
        <template v-slot:action="{ attrs }">
            <v-btn color="primary" text v-bind="attrs" @click="app.hideMessage()">
                Close
            </v-btn>
        </template>
    </v-snackbar>
</template>